import { createFileRoute, notFound } from "@tanstack/react-router";

import { HowtoPage } from "../components/howto/HowtoPage";
import { howtoHead } from "../lib/howto/head";
import { howtoSlugOf, loadHowto } from "../lib/howto/index";
import { HOWTO_UI } from "../lib/howto/ui";
import { documentHeaders } from "../lib/seo";
import { loadToolCopy } from "../lib/tools/index";

/** `/how-to/<slug>`, in English — v1's own address. */
export const Route = createFileRoute("/how-to/$slug")({
  loader: async ({ params }) => {
    const slug = howtoSlugOf(params.slug);
    if (!slug) throw notFound();
    const [bundle, toolCopy] = await Promise.all([
      loadHowto("en"),
      loadToolCopy("en"),
    ]);
    return { slug, bundle, toolCopy };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? howtoHead(
          loaderData.slug,
          "en",
          loaderData.bundle[loaderData.slug],
          HOWTO_UI.en,
        )
      : {},
  component: EnglishGuide,
});

function EnglishGuide() {
  const { slug, bundle, toolCopy } = Route.useLoaderData();
  return (
    <HowtoPage
      slug={slug}
      guide={bundle[slug]}
      ui={HOWTO_UI.en}
      lang="en"
      bundle={bundle}
      toolCopy={toolCopy}
    />
  );
}
